import { faListOl, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
    CadastrarRespostaChatController,
    DeletarRespostaChatController,
    ListarRespostaChatController,
} from "../../../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import { IRespostaChat } from "../../../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";

interface RespostasProps {
    IdCategoria: number;
    updateList: () => void;
}

interface RespostaChatFormData {
    resposta: string;
}

export function Respostas(props: RespostasProps) {
    const { register, handleSubmit, formState, reset } =
        useForm<IRespostaChat>();
    const [lstRespostas, setLstRespostas] = useState<Array<IRespostaChat>>();

    useEffect(() => {
        update(props.IdCategoria);
    }, [props.IdCategoria]);

    function update(idCategoriaRespostaChat: number) {
        ListarRespostaChatController(idCategoriaRespostaChat).then((res) => {
            setLstRespostas(res);
        });
    }

    const handleDeleteRespostaPadraoFormSubmit = (resposta: IRespostaChat) => {
        DeletarRespostaChatController(resposta.ID_RESPOSTA_CHAT).then(() => {
            update(props.IdCategoria);
        });
    };

    const handleRespostaPadraoFormSubmit = (formData: RespostaChatFormData) => {
        CadastrarRespostaChatController({
            ID_RESPOSTA_CHAT: 0,
            DS_RESPOSTA_CHAT: formData.resposta,
            ID_CATEGORIA_RESPOSTA_CHAT: props.IdCategoria,
            DS_CATEGORIA_RESPOSTA_CHAT: "",
        }).then(() => {
            update(props.IdCategoria);
            reset();
        });
    };

    return (
        <>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#RespostaTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#ListRespostas"
                            data-toggle="tab"
                            data-target="#ListRespostas"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faListOl} />
                            </span>
                            <span className="nav-text">Lista Respostas</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#CadastrarRespostas"
                            data-toggle="tab"
                            data-target="#CadastrarRespostas"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faPlus} />
                            </span>
                            <span className="nav-text">
                                Cadastrar Respostas
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <div className="tab-content" id="RespostaTools">
                <div
                    className="tab-pane fade active show"
                    id="ListRespostas"
                    role="tabpanel"
                    aria-labelledby="ListRespostas"
                >
                    <div>
                        <h3 className="mt-7 mb-2">Respostas: </h3>
                        {lstRespostas?.length ? (
                            lstRespostas?.map((resposta) => {
                                return (
                                    <div
                                        className="d-flex flex-column"
                                        style={{ top: 1, cursor: "pointer" }}
                                        key={resposta.ID_RESPOSTA_CHAT}
                                    >
                                        <span className="label label-light-dark font-size-h5 h-auto label-inline mr-2 my-1 d-flex justify-content-between align-items-start ">
                                            {resposta.DS_RESPOSTA_CHAT}
                                            <i
                                                className={`fas fa-times text-danger  font-size-lg pl-2 pt-1`}
                                                onClick={() =>
                                                    handleDeleteRespostaPadraoFormSubmit(
                                                        resposta
                                                    )
                                                }
                                            ></i>
                                        </span>
                                    </div>
                                );
                            })
                        ) : (
                            <div>Não contém respostas cadastradas</div>
                        )}
                    </div>
                </div>

                <div
                    className="tab-pane fade"
                    id="CadastrarRespostas"
                    role="tabpanel"
                    aria-labelledby="CadastrarRespostas"
                >
                    <div className="col-12 mb-5 mt-7">
                        <h5 className="text-center mb-7">
                            Cadastre uma resposta padrão
                        </h5>
                        <span
                            className="label label-light-dark h-auto label-inline mr-2 my-1"
                            style={{ cursor: "grab" }}
                            draggable={true}
                            title="NOME ATENDENTE"
                            onDragStart={(ev) => {
                                ev.dataTransfer.setData("text", "[[DS_NOME]]");
                            }}
                        >
                            NOME ATENDENTE
                        </span>
                        <span
                            className="label label-light-dark h-auto label-inline mr-2 my-1  "
                            style={{ cursor: "grab" }}
                            draggable={true}
                            title="NOME CLIENTE"
                            onDragStart={(ev) => {
                                ev.dataTransfer.setData(
                                    "text",
                                    "[[DS_NOME_CLIENTE]]"
                                );
                            }}
                        >
                            NOME CLIENTE
                        </span>
                        <span
                            className="label label-light-dark h-auto label-inline mr-2 my-1  "
                            style={{ cursor: "grab" }}
                            draggable={true}
                            title="DS_EQUIPE_HELP_DESK"
                            onDragStart={(ev) => {
                                ev.dataTransfer.setData(
                                    "text",
                                    "[[DS_EQUIPE_HELP_DESK]]"
                                );
                            }}
                        >
                            NOME EQUIPE HELP_DESK
                        </span>
                        <span
                            className="label label-light-dark h-auto label-inline mr-2 my-1  "
                            style={{ cursor: "grab" }}
                            draggable={true}
                            title="SAUDAÇÕES"
                            onDragStart={(ev) => {
                                ev.dataTransfer.setData(
                                    "text",
                                    "[[SAUDAÇÕES]]"
                                );
                            }}
                        >
                            Bom Dia/Boa Tarde/Boa Noite
                        </span>
                        <form
                            onSubmit={handleSubmit(
                                handleRespostaPadraoFormSubmit
                            )}
                            className="w-100  mt-2"
                        >
                            <div className="d-flex justify-content-center">
                                <textarea
                                    rows={7}
                                    name="resposta"
                                    className={`form-control placeholder-dark-45 h-200 ${
                                        formState.errors.DS_RESPOSTA_CHAT &&
                                        "is-invalid"
                                    } box-mark`}
                                    placeholder="Resposta Padrão"
                                    ref={register({
                                        required: "Insira uma resposta",
                                    })}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-2">
                                <button className="btn btn-outline-success font-weight-bold d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faPlus}
                                        size="lg"
                                        className="mr-1"
                                    />{" "}
                                    Cadastrar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
